import { IContactClient, IContactClientForm } from '../types'
import { keyBy, flow, mapValues } from 'lodash/fp'

export const formToContact = (contact: IContactClientForm): IContactClient => ({
  ...contact,
  customFields: flow(keyBy('key'), mapValues('value'))(contact.customFields),
})



// WEBPACK FOOTER //
// src/features/Contacts/utils/formToContact.ts